import React, {useState, useEffect} from "react";
import {withTranslation} from "react-i18next";
import "../../cervo.scss";
import {Button, Progress, Spin} from 'antd';
import {CheckCircleOutlined} from "@ant-design/icons";
import {history} from "../../../../../../_helpers";
import {xcService} from "../../../../../../_services/xcService";
import endpoint from "shared/endpoints";

function WorldCervo(props) {

    const {t} =props;
    const [answers, setAnswers] = useState([]);
    const [questions, setQuestions] = useState(-1);
    const [loading, setLoading] = useState(true);
    const [studentArea, setStudentArea] = useState();
    const [studentAreaCervo, setStudentAreaCervo] = useState();
    const fetchData = async () => {
        try {
            let apiEndpoint = endpoint.studentAnswer.getAll('CERVO');
            const responseA = await xcService.getToken(apiEndpoint);
            setAnswers(responseA.data.data)

            apiEndpoint = "/v1/student/assessments/CERVO";
            const responseQ = await xcService.getToken(apiEndpoint);
            setQuestions(responseQ.data.data?.length)
            setLoading(false)


            const areaPath = `/v1/student/area/CEIBA`
            await xcService.getToken(areaPath).then(({data}) => setStudentArea(data.data));

            const areaCevoPath = `/v1/student/area/CERVO`
            await xcService.getToken(areaCevoPath).then(({data}) => setStudentAreaCervo(data.data));


        } catch (e) {
            setLoading(false)
        }


    }
    useEffect(() => {
        fetchData();
    }, []);


    const goTo = () => {
        if (answers && answers.length > 0){
            history.push("/admin/start-cervo")
        }else {
            history.push("/admin/cervo")
        }
    }


    return (
        <div className={"selectQ cervo"}>
            {!loading ?
                <>
                <div className={"wrapper"}>
                    <div>
                        <p>{t("world.stepcervo")}</p>
                        <h2>{t("world.cervo")}</h2>
                    </div>
                    <h3>{t("world.desccervo")}</h3>
                    <Button  onClick={() => goTo()}
                             type={"primary"}
                             className="buttonSizeXM btnBorder"
                    >
                        {t("enter")}
                    </Button>
                    { props.finish && questions === answers.length ?
                      <div className={"posend"}>
                          <CheckCircleOutlined style={{ fontSize: 40}} />
                      </div> :
                      questions !== -1 ?
                        <div className={"posend"}>
                            <Progress width={50} type="circle" percent={ ((answers.length * 100) / (questions)) } format={() => ""} />
                        </div>
                        :
                        <div className={"posend"}></div>
                    }
                </div>
                <Button  onClick={() => goTo()}
                         type={"primary"}
                         className="btnBorder is-mobile-wh"
                >
                    {t("world.mcervo")}
                    {props.finish && questions === answers.length &&
                        <div className={"posendmobile"}>
                            <CheckCircleOutlined style={{fontSize: 14}} /></div>
                    }
                </Button>
                </> : <Spin />}
        </div>
    )
}

export default withTranslation()(WorldCervo);
